/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "assets/theme/base/colors";

const { info, dark, canvas } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
    // Opt-in tabular figures per component (money/IDs/dates), not globally.
    fontVariantNumeric: "normal",
  },
  body: {
    // Flat operational canvas — the template's blue radial gradient is removed.
    backgroundColor: canvas.main,
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  // Visible keyboard focus on every interactive element (redesign §6.B.6).
  "*:focus-visible": {
    outline: "2px solid rgba(23,105,170,0.45)",
    outlineOffset: "1px",
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};

export default globals;
